import { createSelector } from 'reselect';


export function getOrders(state) {
  return state.orders;
}

export function getOrderById(state, orderId) {
  return getOrders(state).get(orderId);
}


//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentOrder = createSelector(
  getOrders,
  orders => orders.get(orders.get('orderId'))
);
